import { gql } from '@apollo/client';
import { DealConfiguratorFragment } from '../fragments/DealConfiguratorFragment';
/**
 * @const DealQuery
 * @since 1.0.0
 */
export const DealQuery = gql `
  query DealQuery($input: DealInput!) {
    deal(input: $input) {
      ...DealConfiguratorFragment
    }
  }

  ${DealConfiguratorFragment}
`;
